import { defineMessages } from 'react-intl';

export default defineMessages({
  optionalLabel: {
    id: 'neptune.Label.optional',
    defaultMessage: '(Optional)',
  },
});
